import React, { Component } from 'react';
import Header from '../header/newheader'
import Footer from '../footer/newfooter';
import Axios from 'axios';
import ReactHtmlParser from 'react-html-parser';
import TopBar from '../topbar/topbar'
import {Link} from 'react-router-dom'
import { BASE } from '../api/api'
import { List } from 'react-content-loader'

class PeriodDesc extends Component {
  constructor(props) {
    super(props);
    this.state = {
      people: '',
      nid: props.match.params.nid,
      bioimg: '',
      loginred: '/login?redir=' + props.location.pathname
    }
  }

  checklogin() {
    let dt = localStorage.getItem('token')
    if (!dt || dt == null) {
      localStorage.setItem('period', this.props.location.pathname)
      localStorage.setItem('period_ret', '/periodicals')
      window.location.href = this.state.loginred
    }
    else
      this.checkexpiry()
      return true

  }

  signout() {
    localStorage.removeItem('token');
    localStorage.removeItem('expirytime');
    localStorage.removeItem('expiryref');
    localStorage.setItem('period', this.props.location.pathname)
      localStorage.setItem('period_ret', '/periodicals')
      window.location.href = this.state.loginred

  }


  refreshexp(){
    let s = new Date();
    s.setSeconds(s.getSeconds()+1800);
    localStorage.setItem('expiryref', s)
  }


  checkexpiry(){
    if(localStorage.getItem('expiryref')){
      let expref=Date.parse(localStorage.getItem('expiryref'))
      let s = new Date();
      if(s>expref){
          this.signout()
      }
      else{
        this.refreshexp()
      }
      
    }
    else{
      this.signout()
       
  }
  }

  // componentWillMount(){
  //   if(this.state.token)
  //       this.checkexpiry()
  // }

  componentWillMount() {
    let url = window.location.href;
    let url_string = url;
    let urlStr = new URL(url_string);
    let nid = urlStr.searchParams.get("nid");
    this.topFunction()
    Axios.get(BASE + 'jsonapi/node/periodicals?include=field_image&filter[langcode][condition][path]=langcode&filter[langcode][condition][value]=en&filter[drupal_internal__nid]=' + this.state.nid)
      .then((data) => {
        console.log(data.data.data[0], "url")
        if (data.data.data[0].relationships.field_image.data !== null) {
          this.setState({
            bioimg: BASE + data.data.included[0].attributes.uri.url
          })
        }
        this.setState({
          people: data.data.data[0].attributes,
        })
      })
  }

  topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  render() {


    if (this.checklogin())
      return (
        <div className='peoplewiki perdesc'>
          <Header />
          <body className="wiki" >
          <div className='top-contents container'>
              <div className="crumbs"><Link to='/'>Home</Link> / <Link to='/periodicals/English/0'>Islamic Finance Periodicals</Link> / {this.props.match.params.nid}</div>
             
            </div>
            {this.state.people ? <div className="main-content">
              <div className="container">
                <div className="row">
                  <div className="node-wiki node">
                    <div style={{ width: this.state.bioimg ? '' : '100%' }} className="group-middle">
                      <div className="field-name-title">
                        <div className='booktitle_rea'>{this.state.people.title}</div>
                      </div>
                      <div>
                        {this.state.bioimg ? <div className="group-left">
                          <div className="field-name-field-thumbnail">
                            <img src={this.state.bioimg} alt="CIS" />
                          </div>
                        </div> : ''}
                        <div className="field field-name-body field-type-text-with-summary field-label-hidden">
                          <div className="field-items">
                            <div className="field-item even" property="content:encoded">
                              {this.state.people.body ? ReactHtmlParser(this.state.people.body.processed) : ''}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> : <List />}
          </body>
          <div className='footer-small-content'><Footer /></div>
        </div>
      )
  }
}


export default PeriodDesc;
